const css = `
.m1 {
  padding: 20px !important;
  box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,0.075) !important;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  background-color: #2a2e2e !important;
  height: 60px;
  box-sizing:border-box;
}

.m1 .c1 {
  flex: 0 0 100%;
  max-width: 95%;
  display: flex !important;
  justify-content: center !important;
  right: 0;
  position: absolute;
  width: 100%;
}

.m1 .c1 img {
  vertical-align: middle;
  border-style: none;
  width: 100px
}

.m1 .c3 {
  position: absolute !important;
  top: 0px
}

.m1 p {
  margin-top: 0;
  margin-bottom: 0
}

.m1_r {
  cursor: pointer;
}

.m1 a {
  color: #FFFFFF;
  text-decoration: none;
  background-color: transparent
}

.m1 .icon-back {
  background-image: url("https://imgs-akamai.mnstatic.com/tools/genericimages/59496583b5306479fa258411ff7955613cce6e54fe1cd264f4f7796e85b106c0.png");
  transform: rotate(180deg);
  background-repeat: no-repeat;
  display: inline-block;
  position: relative;
  width: 10px;
  height: 20px;
  background-size: 10px;
  color: white;
}

.m1 .m1_c {
  position: relative !important;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto
}

@media (min-width: 576px) {
  .m1 .m1_c {
    max-width:540px
  }
}

@media (min-width: 768px) {
  .m1 .m1_c {
    max-width:720px
  }
}

@media (min-width: 992px) {
  .m1 .m1_c {
    max-width:960px
  }
}

@media (min-width: 1200px) {
  .m1 .m1_c {
    max-width:1140px
  }
}`;

export default css;
